import { useQuery } from "@tanstack/react-query";
import api from "@/lib/api";
import { PageHeader, StatusBadge } from "@/components/common";
import { Card } from "@/components/ui/card";
import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from "@/components/ui/table";
import { Clock } from "lucide-react";
import AttendanceWidget from "@/components/AttendanceWidget";
import AttendanceCorrections from "@/components/AttendanceCorrections";

export default function MyAttendance() {
  const { data: status } = useQuery({
    queryKey: ["attendanceStatus"], queryFn: async () => (await api.get("/my/attendance/status")).data,
  });
  const { data: history } = useQuery({
    queryKey: ["attendanceHistory"], queryFn: async () => (await api.get("/my/attendance/history")).data,
    enabled: !!status?.enrolled,
  });

  return (
    <div>
      <PageHeader overline="Daily" title="My Attendance" icon={Clock}
        subtitle="Mark today's attendance and review your check-in / check-out history below." />

      <AttendanceWidget />

      <AttendanceCorrections />

      {history && history.length > 0 && (
        <Card className="border-slate-200 shadow-none overflow-hidden">
          <Table>
            <TableHeader><TableRow className="bg-slate-50">
              <TableHead className="overline text-slate-500">Date</TableHead>
              <TableHead className="overline text-slate-500">Location</TableHead>
              <TableHead className="overline text-slate-500">Check-in</TableHead>
              <TableHead className="overline text-slate-500">Check-out</TableHead>
              <TableHead className="overline text-slate-500">Hours</TableHead>
              <TableHead className="overline text-slate-500">Status</TableHead>
            </TableRow></TableHeader>
            <TableBody>
              {history.map((h) => (
                <TableRow key={h.id} className="table-row-i">
                  <TableCell className="font-mono-i text-sm text-teal">{h.date}</TableCell>
                  <TableCell className="text-slate-600">{h.location_name}</TableCell>
                  <TableCell className="text-slate-600">{h.check_in_time ? new Date(h.check_in_time).toLocaleTimeString() : "—"}</TableCell>
                  <TableCell className="text-slate-600">{h.check_out_time ? new Date(h.check_out_time).toLocaleTimeString() : "—"}</TableCell>
                  <TableCell className="text-slate-600">{h.hours_worked ?? "—"}</TableCell>
                  <TableCell><StatusBadge status={h.status} />{h.regularized && <span className="ml-2 text-[11px] text-teal" title={`Corrected by ${h.regularized_by}`}>Corrected</span>}</TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </Card>
      )}
    </div>
  );
}
